import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { StoreConfigService } from './store-config.service';
import { ProductPage, ProductService, ProductFilters, ProductSort } from './product.service';

/** Capa fina sobre ProductService — separado para que mañana la búsqueda pueda tener su propio endpoint/motor (Algolia, Elasticsearch, etc.) sin tocar el catálogo. */
export interface SearchSuggestion {
  name: string;
  slug: string;
  image?: string;
  price: number;
}

@Injectable({ providedIn: 'root' })
export class SearchService {
  private productService = inject(ProductService);
  private http = inject(HttpClient);
  private storeConfig = inject(StoreConfigService);

  /** Hasta 6 productos para el desplegable del buscador; `searchedAs` = lo que se buscó tras corregir un tipeo. */
  suggest(q: string): Observable<{ data: SearchSuggestion[]; searchedAs?: string }> {
    return this.http.get<{ data: SearchSuggestion[]; searchedAs?: string }>(`${environment.apiUrl}/store/${this.storeConfig.currentSlug()}/suggest`, {
      params: new HttpParams().set('q', q),
    });
  }

  search(q: string, sort: ProductSort = 'relevance', page = 1, pageSize = 12, filters: ProductFilters = {}): Observable<ProductPage> {
    return this.productService.getAll({ ...filters, q }, sort, page, pageSize);
  }
}
